import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';
import { DialogService } from 'primeng/dynamicdialog';
import { OktaAuthGuard } from '@okta/okta-angular';
import { environment } from 'src/environments/environment';

export type FeatureFlagName = 'enableAssayManagement' | 'enableConfigurationManagement' | 'enableNotificationManagement';

@Injectable({
  providedIn: 'root'
})
export class ApplicationAuthGuard {
  private authService = inject(AuthService);
  private oktaAuthGuard = inject(OktaAuthGuard);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.authService.hasLocalSession()) {
      const authenticated = await this.authService.initializeLocalSession();
      if (!authenticated) {
        await this.router.navigate(['/security-login'], { replaceUrl: true });
      }
      return authenticated;
    }
    return this.oktaAuthGuard.canActivate(route, state);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  authService = inject(AuthService);
  private router = inject(Router);


  canActivate(): boolean {
      if(this.authService.user != null)
      {
        return true;
      }
      else {
        this.router.navigate(['/home']);
        return false;
      }
    } 

}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard {
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const featureFlag = route.data['featureFlag'] as FeatureFlagName | undefined;
    return featureFlag && environment[featureFlag]
      ? true
      : this.router.createUrlTree(['/home']);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnnouncementManagementGuard {
  authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    const user = this.authService.user;
    const allowed = Boolean(user?.role) && !this.authService.getDeIdentifiedMode();
    return allowed ? true : this.router.createUrlTree(['/home']);
  }
}

/**MP-116 User can circumvent witness requirements for the waste page by directly navigating to the URLs. */
@Injectable({
  providedIn: 'root'
})
export class WitnessGuardService {
  authService = inject(AuthService);
  private router = inject(Router);



  canActivate(): boolean {
      if(this.authService.getWitnessToken() != null)
        {
          return true;
        }
        else {
          this.router.navigate(['/home']);
          return false;
        }
    }
  }

  @Injectable({
    providedIn: 'root'
  })
  export class DdpsGuardService {
    authService = inject(AuthService);
    dialogService = inject(DialogService);

  
    canActivate(): boolean {
      return true
      // if(this.authService.user.role == 'DDPS')
      //   {
      //     this.router.navigate(['/home']);
      //     this.dialogService.open(UnauthorizedComponent, {})
      //   }
      // else {
      //  return true;
      // }
    }
  }
